import { Grid } from "@material-ui/core";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
import MaterialTable from "material-table";
import React, { useMemo, useState } from "react";
import { BoxCard, PageLayout } from "ui/componentes";
import { LocalizationPTBr } from "util/MaterialTableUtil";
import { Collections } from "api/model/Collections";
import { useCollection } from "api/hooks/useCollection";
import { Car } from "api/model/Car";
import { CarForm } from "ui/views/CarsView/CarForm";
import { Brand } from "api/model/Brand";
import { red } from "@material-ui/core/colors";

const CarsView = () => {
    const [carEditing, setCarEditing] = useState<Car | undefined>();
    const cars =
        useCollection<Car[]>(
            {
                collection: Collections.CARS,
            },
            true
        ) || [];
    const brandsById =
        useCollection<Brand[]>({ collection: Collections.BRANDS }) || {};

    const sortedCars = useMemo(() => {
        return sortBy(cars, ["name"]);
    }, [cars]);

    return (
        <PageLayout
            title="Carros"
            boxCardProps={{ padding: 0 }}
            showInBoxCard={false}
        >
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CarForm
                        car={carEditing}
                        onCancel={() => setCarEditing(undefined)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <MaterialTable
                        components={{ Container: BoxCard }}
                        columns={[
                            {
                                field: "brandId",
                                title: "Marca",
                                align: "center",
                                filtering: false,
                                sorting: false,
                                render: (car) => {
                                    const brand = brandsById[car.brandId];
                                    return (
                                        <img
                                            src={brand.image.downloadURL}
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "60px",
                                            }}
                                            alt="logo-brand"
                                        />
                                    );
                                },
                            },
                            {
                                field: "image",
                                title: "Imagem",
                                align: "center",
                                filtering: false,
                                sorting: false,
                                render: (car) => {
                                    if (!car.image) return "";
                                    return (
                                        <img
                                            src={car.image.downloadURL}
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "60px",
                                            }}
                                            alt="logo-brand"
                                        />
                                    );
                                },
                            },
                            {
                                field: "classIRacingID",
                                title: "Classe",
                            },
                            {
                                field: "carIRacingID",
                                title: "ID no iRacing",
                                align: "right",
                            },
                            {
                                field: "name",
                                title: "Nome",
                            },
                            {
                                field: "model",
                                title: "Modelo",
                            },
                            {
                                field: "description",
                                title: "Descrição",
                            },
                        ]}
                        data={cloneDeep(sortedCars)}
                        actions={[
                            {
                                icon: "edit",
                                tooltip: "Editar",
                                onClick: (event, rowData) =>
                                    setCarEditing(rowData as Car),
                            },
                        ]}
                        options={{
                            filtering: true,
                            pageSize: 10,
                            toolbar: false,
                            rowStyle: (data) => {
                                const row = data as Car;
                                if (row.id === carEditing?.id) {
                                    return {
                                        backgroundColor: red["100"],
                                    };
                                }
                                return {};
                            },
                        }}
                        localization={LocalizationPTBr}
                    />
                </Grid>
            </Grid>
        </PageLayout>
    );
};

export { CarsView };
